import { useState } from "react";
import { Tooltip, IconButton } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SubmitSnackbar from "./SubmitSnackbar";

export default function CopyTextButton({
  copyText,
  label,
  disabled,
  disableText,
  Control = null,
  controlProps = {},
}) {
  const [sb, setSb] = useState({ severity: "success", message: "" });
  const sbSuccess = (msg) => setSb({ severity: "success", message: msg });
  const sbError = (msg) => setSb({ severity: "error", message: msg });
  const sbClose = () => setSb((prev) => ({ ...prev, message: "" }));

  const tooltipTitle = disabled ? `Copy ${label}` : disableText;

  const handleClick = () => {
    navigator.clipboard
      .writeText(copyText)
      .then(() => sbSuccess(`${label} copied!`))
      .catch((err) => sbError(err.message));
  };

  return (
    <>
      <Tooltip title={tooltipTitle}>
        <span>
          {!Control ? (
            <IconButton disabled={disabled} size="small" onClick={handleClick}>
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          ) : (
            <Control {...controlProps} onClick={handleClick} />
          )}
        </span>
      </Tooltip>
      <SubmitSnackbar
        open={!!sb.message}
        onClose={sbClose}
        message={sb.message}
        severity={sb.severity}
      />
    </>
  );
}
